import { render, staticRenderFns } from "./QuickCreateMenu.vue?vue&type=template&id=10a1d234&scoped=true&"
import script from "./QuickCreateMenu.vue?vue&type=script&lang=ts&"
export * from "./QuickCreateMenu.vue?vue&type=script&lang=ts&"
import style0 from "./QuickCreateMenu.vue?vue&type=style&index=0&id=10a1d234&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a1d234",
  null
  
)

export default component.exports